import script from "./AllergyList.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllergyList.vue?vue&type=script&setup=true&lang=ts"

import "./AllergyList.vue?vue&type=style&index=0&id=5f58f0a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f58f0a6"]])

export default __exports__